// The counter cards above the ShareJet bookings table: what each counts and what clicking it filters to.
import type { BookingCounts, BookingStatus } from '../../api/types';
import { ADHOC_COLORS } from '../../components/AdhocTag';
import { BOOKING_STATUS_COLORS, BOOKING_STATUS_LABELS } from '../../data/statuses';

// The counter cards shown above the table. `key` maps to a slice of the
// counts payload; `status`/`mgav` drive what clicking the card filters to.
export type CounterDef = {
  key: keyof BookingCounts;
  label: string;
  color?: string;
  status?: BookingStatus;
  mgav?: boolean;
  newSeats?: boolean;
  notPaid?: boolean;
  passportNeeded?: boolean; // SHAR-451
};

export const COUNTERS: CounterDef[] = [
  { key: 'total', label: 'Total' },
  {
    key: 'confirmed',
    label: BOOKING_STATUS_LABELS.confirmed,
    color: BOOKING_STATUS_COLORS.confirmed,
    status: 'confirmed',
  },
  {
    key: 'pre_approved',
    label: BOOKING_STATUS_LABELS.pre_approved,
    color: BOOKING_STATUS_COLORS.pre_approved,
    status: 'pre_approved',
  },
  {
    key: 'pending',
    label: BOOKING_STATUS_LABELS.pending,
    color: BOOKING_STATUS_COLORS.pending,
    status: 'pending',
  },
  {
    key: 'cancelled',
    label: BOOKING_STATUS_LABELS.cancelled,
    color: BOOKING_STATUS_COLORS.cancelled,
    status: 'cancelled',
  },
  { key: 'mgavOverdue', label: 'MGAV overdue', color: 'volcano', mgav: true },
  { key: 'newSeats', label: 'New seats booked', color: 'gold', newSeats: true },
  { key: 'passportNeeded', label: 'Passport needed', color: ADHOC_COLORS.passportNeededList, passportNeeded: true }, // SHAR-451
  // SHAR-159 — "Payment required": a seat-holder's money has gone (their pre-auth
  // lapsed) and they have not paid again. Same flag as SHAR-163's "Not paid".
  { key: 'notPaid', label: 'Payment required', color: 'red', notPaid: true }, // SHAR-163
];
